import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

const els = document.querySelectorAll('.element-projects')

export default {
  can: () => els.length,
  run: () => {
    els.forEach((el) => {
      const projects = el.querySelectorAll('.project-item')

      projects.forEach((project) => {
        const projectText = project.querySelectorAll('.project-text')

        gsap.set(projectText, {
          opacity: 0,
          y: '50%',
        })

        gsap.to(projectText, {
          opacity: 1,
          y: 0,
          duration: 0.8,
          stagger: 0.5,
          paused: true,
          ease: 'power4',
          scrollTrigger: {
            trigger: project,
            start: 'top 30%',
            markers: false,
          },
        })
      })
    })
  },
}
